// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LeftOutlinedSvg from "@ant-design/icons-svg/es/asn/LeftOutlined";
import AntdIcon from '../components/AntdIcon';

var LeftOutlined = function LeftOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LeftOutlinedSvg
  }));
};

LeftOutlined.displayName = 'LeftOutlined';
export default React.forwardRef(LeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/LeftOutlined.js
// module id = 1401
// module chunks = 0